import { isAPP } from './util';
// 心悦
export const TGCLUB = {
  NAME: 'tgclub',
  QC_APP_ID: '101478665',
  QC_REDIRECT_URI: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
  WX_APP_ID: 'wx5a3bbeac0d87c75a',
  WX_SAFARI_APP_ID: 'wx5f930f997198dbd6', // safari下微信用游戏家公会
  WX_GAME_DOMAIN: 'act.xinyue.qq.com',
  IOS_DOWNLOAD_URL: '//itunes.apple.com/cn/app/%E5%BF%83%E6%82%A6%E4%BF%B1%E4%B9%90%E9%83%A8-%E8%85%BE%E8%AE%AF%E6%B8%B8%E6%88%8F%E7%8E%A9%E5%AE%B6%E7%A6%8F%E5%88%A9%E5%B9%B3%E5%8F%B0/id1156439976?mt=8',
  ANDROID_DOWNLOAD_URL: '//sj.qq.com/myapp/detail.htm?apkName=com.tencent.tgclub',
  UNIVERSAL_LINK: '//static.xinyue.qq.com/iosredirect',
  XY_APP_ICON: 'https://dlied5.myapp.com/myapp/6337/tgclub/png/20200218/b8852a03f5a132aeb89b19112726755d.png',
  SHARE_WX_APP_ID: 'wxf8773b4d31a9a719',
  LOGO_URL: 'https://act.xinyue.qq.com/assets/img/tgclub-logo.png',
};
// 超核
export const SUPERCORE = {
  NAME: 'supercore',
  QC_APP_ID: '101813972',
  QC_REDIRECT_URI: 'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html',
  WX_APP_ID: 'wxfb66a4e99e630765',
  WX_SAFARI_APP_ID: 'wx5f930f997198dbd6', // safari下微信用游戏家公会
  WX_GAME_DOMAIN: 'supercore.qq.com',
  LOGO_URL: 'https://act.supercore.qq.com/assets/img/supercore-logo.png',
  SHARE_WX_APP_ID: 'wxf8773b4d31a9a719',
};
// 知几
export const GBOT = {
  NAME: 'gbot',
  QC_APP_ID: '101491592',
  QC_REDIRECT_URI: 'https://milo.qq.com/comm-htdocs/login/qc_redirect.html',
  WX_APP_ID: 'wx670228280e32b3de',
  WX_GAME_DOMAIN: 'act.gbot.qq.com',
  LOGO_URL: 'https://act.gbot.qq.com/assets/img/gbot-logo.png',
};
// 闪现
export const SPARK = {
  NAME: 'spark',
  QC_APP_ID: isAPP() ? '101821651' : '101863397',
  QC_REDIRECT_URI: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
  WX_APP_ID: isAPP() ? 'wxd35a5b0c66e8b683' : 'wx3a42583c51c6b803',
  WX_GAME_DOMAIN: 'ceiba.shanxian.qq.com',
  LOGO_URL: 'https://ceiba.shanxian.qq.com/assets/img/spark-logo.png',
};
// 垂直社区
export const BB = {
  NAME: 'bb',
  QC_APP_ID: '101478665',
  QC_REDIRECT_URI: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
  WX_APP_ID: 'wx5a3bbeac0d87c75a',
  WX_GAME_DOMAIN: 'act.xinyue.qq.com',
  DOWNLOAD_URL: '//a.app.qq.com/o/simple.jsp?pkgname=com.tencent.qt.sns',
  GAMEINFO: {
    0: {
      gameId: '0',
      subGameId: '0',
      icon: '0',
      color: '#000000',
      title: '腾讯游戏',
      name: '腾讯游戏助手',
      context: '来和游戏在线的好友聊天吧',
    },
    //  '0': {'icon': '0', 'color': '#000000', 'title': '腾讯游戏', 'name': '腾讯游戏助手', 'context': '来和游戏在线的好友聊天吧'},
    213: {
      gameId: '10002',
      subGameId: '10002',
      icon: '10002',
      color: '#000000',
      title: '天刀助手',
      name: '天涯明月刀',
      context: '来和游戏在线的好友聊天吧',
    },  // 213  gameid  subgameid
    214: {
      gameId: '10010',
      subGameId: '10010',
      icon: '10010',
      color: '#000000',
      title: '使命召唤OL助手',
      name: '使命召唤OL',
      context: '最新资讯一网打尽',
    },   // 214  gameid  subgameid
    40: {
      gameId: '10012',
      subGameId: '10012',
      icon: '10012',
      color: '#000000',
      title: '逆战助手',
      name: '逆战助手',
      context: '游戏战绩一手掌握',
    },           // 40  gameid  subgameid
    17: {
      gameId: '10013',
      subGameId: '10013',
      icon: '10013',
      color: '#599ef4',
      title: '掌上飞车',
      name: 'QQ飞车',
      context: '与千万车手一起探索无限乐趣！',
    },   // 17  gameid  subgameid
    1: {
      gameId: '10014',
      subGameId: '10014',
      icon: '10014',
      color: '#000000',
      title: 'DNF助手',
      name: '地下城与勇士',
      context: '阿拉德的勇士们都在这里！',
    },  // 1  gameid  subgameid   10014
    1338: {
      gameId: '10014',
      subGameId: '20014',
      icon: '20014',
      color: '#000000',
      title: 'DNF助手',
      name: '地下城与勇士',
      context: '阿拉德的勇士们都在这里！',
    },  // 1338  gameid 10014  subgameid  20014
    10: {
      gameId: '10020',
      subGameId: '10020',
      icon: '10020',
      color: '#000000',
      title: '炫舞小灵通',
      name: 'QQ炫舞',
      context: '来和游戏在线的好友聊天吧',
    }, // 10
    80: {
      gameId: '10021',
      subGameId: '10021',
      icon: '10021',
      color: '#000000',
      title: '炫舞时代助手',
      name: '炫舞时代',
      context: '每天挂机领奖,社区八卦,好友聊天',
    },  // 80  gameid   subgameid   10021
    234: {
      gameId: '10032',
      subGameId: '10032',
      icon: '10032',
      color: '#000000',
      title: '极品飞车OL助手',
      name: '极品飞车',
      context: '看资讯与游戏好友聊天吧',
    }, // 234
    1191: {
      gameId: '20001',
      subGameId: '20001',
      icon: '20001',
      color: '#000000',
      title: '王者荣耀助手',
      name: '王者荣耀',
      context: '战绩查询、资讯攻略、看赛事直播',
    }, // 1191
    1261: {
      gameId: '1003',
      subGameId: '20006',
      icon: '10013',
      color: '#599ef4',
      title: '掌上飞车',
      name: 'QQ飞车手游',
      context: '与千万车手一起探索无限乐趣！',
    },  // 1261  gameid  1003  subgameid 20006
    20006: { icon: '10013', color: '#599ef4', title: '掌上飞车', name: 'QQ飞车手游', context: '与千万车手一起探索无限乐趣！' },
    1001: { icon: '1001', color: '#000000', title: '掌上穿越火线', name: '掌上穿越火线', context: '4亿CFer的聚集地!' },
    2: {
      gameId: '10011',
      subGameId: '10011',
      icon: '1001',
      color: '#000000',
      title: '掌上穿越火线',
      name: '掌上穿越火线',
      context: '4亿CFer的聚集地!',
    },
    248: {
      gameId: '10038',
      subGameId: '10038',
      icon: '1001',
      color: '#000000',
      title: '掌上穿越火线',
      name: '掌上穿越火线',
      context: '4亿CFer的聚集地!',
    },
    251: {
      gameId: '10040',
      subGameId: '10040',
      icon: '1010',
      color: '#000000',
      title: '掌上命运方舟',
      name: '掌上命运方舟',
      context: '方舟集聚 冒险领航！',
    },
    1194: {
      gameId: '20003',
      subGameId: '20003',
      icon: '1001',
      color: '#000000',
      title: '掌上穿越火线',
      name: '掌上穿越火线',
      context: '4亿CFer的聚集地!',
    },
  },
};
export default {
  TGCLUB,
  SUPERCORE,
  GBOT,
  SPARK,
  BB,
};
